import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { isApp } from '../bridge';
import { buildLocalePath } from '../utils/locale.utils';

export const useLocalePath = () => {
  const { i18n } = useTranslation();

  return useCallback(
    (path) => {
      if (isApp()) return path;
      return buildLocalePath(i18n.language, path);
    },
    [i18n.language],
  );
};
